import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import {
  setFacilityEditValue,
  setFacilityList,
  setFloorEditValue,
  setFloorList,
  setRoomEditValue,
  setRoomList
} from 'src/store/modules/admin'

import {
  FACILITY_MANAGMENT_SAVE_MESSAGE,
  FACILITY_MANAGMENT_UPDATE_MESSAGE,
  FLOOR_MANAGMENT_SAVE_MESSAGE,
  FLOOR_MANAGMENT_UPDATE_MESSAGE,
  GET_FACILITY_LIST,
  GET_FLOOR_LIST,
  GET_PATCH_FACILITY,
  GET_PATCH_FLOOR,
  GET_PATCH_ROOM,
  GET_ROOM_LIST,
  PATCH_ROOM_ORDER_NUMBER,
  POST_FACILITY,
  POST_FLOOR,
  POST_ROOM,
  ROOM_MANAGMENT_SAVE_MESSAGE,
  ROOM_MANAGMENT_UPDATE_MESSAGE
} from 'src/constants'
import { showSuccessModal } from 'src/services/dialogs'

export const getFacilityList = async (config = {}) => {
  const { params = {}, query = {} } = config

  try {
    const { items = [] } = await httpClient.request({
      method: 'get',
      url: {
        pathname: GET_FACILITY_LIST,
        params,
        query
      }
    })

    return items
  } catch (err) {
    catchError(err)

    return []
  }
}

export const fetchFacilityList =
  (config = {}) =>
  async (dispatch) => {
    const { params = {}, query = {} } = config

    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_FACILITY_LIST,
          params,
          query
        }
      })

      dispatch(setFacilityList(items))

      return meta
    } catch (err) {
      catchError(err)
    }
  }

export const fetchFacilityEditValue =
  (config = {}) =>
  async (dispatch) => {
    const { params = {} } = config

    try {
      const item = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_PATCH_FACILITY,
          params
        }
      })

      dispatch(setFacilityEditValue(item))
    } catch (err) {
      catchError(err)
    }
  }

export const saveFacility =
  (config = {}) =>
  async () => {
    const { payload } = config

    try {
      await httpClient.request({
        method: 'post',
        url: {
          pathname: POST_FACILITY
        },
        payload
      })

      showSuccessModal({
        content: FACILITY_MANAGMENT_SAVE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const updateFacility =
  (config = {}) =>
  async () => {
    const { payload = {}, params = {} } = config

    try {
      await httpClient.request({
        method: 'patch',
        url: {
          pathname: GET_PATCH_FACILITY,
          params
        },
        payload
      })

      showSuccessModal({
        content: FACILITY_MANAGMENT_UPDATE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const getFloorList = async (config = {}) => {
  const { params = {}, query = {} } = config

  try {
    const response = await httpClient.request({
      method: 'get',
      url: {
        pathname: GET_FLOOR_LIST,
        params,
        query
      }
    })

    return response
  } catch (err) {
    catchError(err)

    return {}
  }
}

export const fetchFloorList =
  (config = {}) =>
  async (dispatch) => {
    try {
      const { items = [], meta = {} } = await getFloorList(config)

      dispatch(setFloorList(items))

      return meta
    } catch (err) {
      catchError(err)
    }
  }

export const fetchFloorEditValue =
  (config = {}) =>
  async (dispatch) => {
    const { params = {} } = config

    try {
      const item = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_PATCH_FLOOR,
          params
        }
      })

      dispatch(setFloorEditValue(item))
    } catch (err) {
      catchError(err)
    }
  }

export const saveFloor =
  (config = {}) =>
  async () => {
    const { payload } = config

    try {
      await httpClient.request({
        method: 'post',
        url: {
          pathname: POST_FLOOR
        },
        payload
      })

      showSuccessModal({
        content: FLOOR_MANAGMENT_SAVE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const updateFloor =
  (config = {}) =>
  async () => {
    const { payload = {}, params = {} } = config

    try {
      await httpClient.request({
        method: 'patch',
        url: {
          pathname: GET_PATCH_FLOOR,
          params
        },
        payload
      })

      showSuccessModal({
        content: FLOOR_MANAGMENT_UPDATE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const getRoomList = async (config = {}) => {
  const { params = {}, query = {} } = config

  try {
    const response = await httpClient.request({
      method: 'get',
      url: {
        pathname: GET_ROOM_LIST,
        params,
        query
      }
    })

    return response
  } catch (err) {
    catchError(err)

    return {}
  }
}

export const fetchRoomList =
  (config = {}) =>
  async (dispatch) => {
    try {
      const { items = [], meta = {} } = await getRoomList(config)

      dispatch(setRoomList(items))

      return meta
    } catch (err) {
      catchError(err)
    }
  }

export const fetchRoomEditValue =
  (config = {}) =>
  async (dispatch) => {
    const { params = {} } = config

    try {
      const item = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_PATCH_FLOOR,
          params
        }
      })

      dispatch(setRoomEditValue(item))
    } catch (err) {
      catchError(err)
    }
  }

export const saveRoom =
  (config = {}) =>
  async () => {
    const { payload } = config

    try {
      await httpClient.request({
        method: 'post',
        url: {
          pathname: POST_ROOM
        },
        payload
      })

      showSuccessModal({
        content: ROOM_MANAGMENT_SAVE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const updateRoom =
  (config = {}) =>
  async () => {
    const { payload = {}, params = {} } = config

    try {
      await httpClient.request({
        method: 'patch',
        url: {
          pathname: GET_PATCH_ROOM,
          params
        },
        payload
      })

      showSuccessModal({
        content: ROOM_MANAGMENT_UPDATE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const updateRoomOrderNumber =
  (config = {}) =>
  async () => {
    const { payload = {}, params = {} } = config

    try {
      await httpClient.request({
        method: 'patch',
        url: {
          pathname: PATCH_ROOM_ORDER_NUMBER,
          params
        },
        payload
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }
